export const sortTypes = {
  string: 'string',
  number: 'number',
  arrLength: 'arrLength',
  date: 'date',
};
